import { render, staticRenderFns } from "./ArticleCard.vue?vue&type=template&id=fb97575c&functional=true&"
import script from "./ArticleCard.vue?vue&type=script&lang=ts&"
export * from "./ArticleCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports